const contractActionUtils = {
  REMOVE_CONTRACT: "REMOVE_CONTRACT",
  SAVE_CONTRACT: "SAVE_CONTRACT",
  USERS_ASSIGNED: "USERS_ASSIGNED",
};

export default contractActionUtils;
